/* eslint-disable import/no-cycle */
/* eslint-disable react/no-danger */
import React from 'react';
import IllnessJPG from '@assets/images/illness.jpg';
import IllnessMobileJPG from '@assets/images/illness-mobile.jpg';
import { ContainerSmall } from '~/utils/styles/utils';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';
import { useTranslationContext } from '~/pages/parkinson-therapie';
import { useTranslationContext as useTranslationContextEn } from '~/pages/en/parkinson-therapy';

const ParkinsonPage: React.FC = () => {
  const t = useTranslationContext();
  const tEn = useTranslationContextEn();

  return (
    <>
      <HeaderFooterLayout
        desktopHero={IllnessJPG}
        mobileHero={IllnessMobileJPG}
        altHero="Modell eines Gehirns zur Krankheitserklärung von Parkinson."
        enLink="/en/parkinson-therapy/"
        deLink="/parkinson-therapie/"
      >
        <ContainerSmall>
          <div
            dangerouslySetInnerHTML={{
              __html: t('ParkinsonContent1') || tEn('ParkinsonContent1'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('ParkinsonContent2') || tEn('ParkinsonContent2'),
            }}
          />
        </ContainerSmall>
      </HeaderFooterLayout>
    </>
  );
};

export default ParkinsonPage;
